import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EmploymentEffects, employmentReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([EmploymentEffects]), StoreModule.forFeature(`employment`, employmentReducer)]
})
export class EmploymentStateModule {}
